import _ from 'underscore';
import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const Dropdown = ({ options, buttonElement, tabIndex }) => {
	const [isOpen, setIsOpen] = useState(false);

	const toggleMenu = useCallback(() => {
		setIsOpen(!isOpen);
	}, [isOpen]);

	const Button = useMemo(
		() =>
			React.cloneElement(buttonElement, {
				onClick: toggleMenu
			}),
		[buttonElement, toggleMenu]
	);

	const menuCx = cx(styles.menu, {
		[styles.show]: isOpen
	});

	const handleBlur = (event) => {
		const { relatedTarget } = event;

		const isHasLinkUserMenu = !!options.find(
			(item) => item.link === relatedTarget?.getAttribute('href')
		);

		if (!isHasLinkUserMenu) {
			setIsOpen(false);
		}
	};

	return (
		<div>
			<div>{Button}</div>
			<div>
				<div className={menuCx}>
					{_(options).map((option) => (
						<a
							key={option.link}
							className={styles.button}
							href={option.link}
							tabIndex={tabIndex}
							onBlur={handleBlur}
						>
							<span className={styles.text}>{option.text}</span>
						</a>
					))}
				</div>
			</div>
		</div>
	);
};

Dropdown.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			text: PropTypes.string.isRequired,
			link: PropTypes.string.isRequired
		})
	).isRequired,
	buttonElement: PropTypes.element.isRequired,
	tabIndex: PropTypes.number
};

export default Dropdown;
